import { SharedState } from '@trello/shared-state';

export type SmartScheduledCardPlannerEvent = {
  id: string;
  start: string;
  end: string;
  duration: number;
  eventId: string;
  title: string;
  durationEditable: true;
  startEditable: true;
};

const initialState: {
  activeIndex: number;
  proposedEvents: SmartScheduledCardPlannerEvent[];
} = {
  activeIndex: 0,
  proposedEvents: [],
};

export const smartScheduledCardsSharedState = new SharedState<
  typeof initialState
>(initialState);
